<template>
  <exercise-logic
    exCollection="successExCollection"
    @ready="onReady"
    @error="onError"
    @saved="onSaved"
    @savedNext="onSavedNext"
    @loadedEx="onLoadedEx"
    @loadedRefs="onLoadedRefs"
    :doc="doc"
    :shared="false"
    :saveState="saveState"
  >
    <template slot-scope="{ saveExercise }">
      <v-row>
        <v-col cols="4" class="mb-4">
          <h2 class="headline" v-text="$t('exercise_success.step1.title')"></h2>
        </v-col>
        <v-col cols="8" lg="6" class="mb-4">
          <p
            v-for="(item, index) in $t('exercise_success.step1.description')"
            :key="index"
            v-text="item"
          />
        </v-col>
      </v-row>
      <v-row v-if="doc">
        <v-col cols="6">
          <v-card height="100%"
            ><v-card-text>
              <unit-items-icon
                v-model="doc.success1"
                :limit="10"
                name="short"
                title="Short term goals"
                color="amber"
                size="contain"
                svg="Do.svg"
                @autosave="doAutoSave"
              >
              </unit-items-icon> </v-card-text
          ></v-card>
        </v-col>
        <v-col cols="6">
          <v-card height="100%"
            ><v-card-text>
              <unit-items-icon
                v-model="doc.success2"
                :limit="10"
                name="long"
                title="Long term goals"
                color="amber"
                size="contain"
                svg="Thought.svg"
                @autosave="doAutoSave"
              >
              </unit-items-icon> </v-card-text
          ></v-card>
        </v-col>
      </v-row>
      <bottom-navigation
        :save="true"
        :next="false"
        :prev="false"
        :gridView="false"
        :gridToggle="false"
        @save="saveExercise"
        @prev="prevStep"
        @next="saveExercise(false)"
      >
      </bottom-navigation>
      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-card-title
            class="headline"
            v-text="$t('exercise_success.saved.title')"
          ></v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="amber" text @click="closeDialog">
              Close
            </v-btn>

            <v-btn
              color="amber accent-1"
              text
              :to="`/users/project/${$route.params.id}`"
            >
              Back to Project
            </v-btn>
            <v-btn color="amber accent-1" text to="/users/dashboard">
              Back to Dashboard
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </exercise-logic>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogic } from "@/components/exercises";
import { UnitItemsIcon } from "@/components/units";

// const fb = require("@/firebaseConfig.js");

export default {
  name: "UserSuccess",
  data() {
    return {
      e1: 1,
      doc: {
        success1: [],
        success2: [],
      },
      tabs: [{ title: "What does success look like?", count: 1 }],
      userSelected: null,
      debug: false,
      dialog: false,
      saveState: false,
      autoSave: true,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogic,
    UnitItemsIcon,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },

  mounted() {},
  methods: {
    nextStep() {
      this.e1++;
      // this.saveExercise(false);
    },
    prevStep() {
      this.e1--;
      // this.saveExercise(false);
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved");
      this.dialog = true;
      this.saveState = false;
    },
    onLoadedRefs(refs) {
      console.log("loaded", refs);
    },
    onLoadedEx(ex) {
      this.doc = ex.doc;
      this.exercise = ex;
    },
    onSavedNext() {
      this.nextStep();
      this.saveState = false;
    },
    closeDialog() {
      this.dialog = false;
    },
    doAutoSave() {
      if (this.autoSave) {
        console.log("doing autosave");
        this.saveState = true;
      }
    },
  },
};
</script>
